import Vue from 'vue'

const state = {
  baseUri: '/botw/config/consignComp/'
}
const getters = {
}
const actions = {
  codes: function (_context, [data, callback]) { // 지자체 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes',
      params: data
    }
    console.log('actions codes axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  searchDong: function (_context, [data, callback]) { // 법정동 조회
    const reqData = {
      level: data.level,
      upperDongCode: data.dongCode
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/consignComp/dongSearch',
      params: reqData
    }
    console.log('actions consignComp axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, callback]) { // 내역 조회
    const reqData = {
      consignCompName: searchParam.consignCompName,
      hnDuruGubun: searchParam.hnDuruGubun,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [consignCompSeq, callback]) { // 상세 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + consignCompSeq
    }
    console.log('actions detail axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [data, callback]) { // 등록
    let reqData = {}
    if (data.hnDuruGubun.indexOf('홈네트워크') >= 0 && data.hnDuruGubun.indexOf('정보통신') >= 0) {
      reqData = {
        hnDuruGubun: data.hnDuruGubun,
        consignCompName: data.consignCompName,
        businessNum: data.businessNum,
        representative: data.representative,
        mainPhoneNum: data.mainPhoneNum,
        fax: data.fax,
        email: data.email,
        dongCode: data.dongCode,
        extraAddress: data.extraAddress,
        // tbFile: data.tbFile,
        fileCode: data.fileCode,
        note: data.note
        // hnFlag: String(true),
        // duruFlag: String(true)
      }
    } else if (data.hnDuruGubun.indexOf('홈네트워크') >= 0 && data.hnDuruGubun.indexOf('정보통신') < 0) {
      reqData = {
        hnDuruGubun: data.hnDuruGubun,
        consignCompName: data.consignCompName,
        businessNum: data.businessNum,
        representative: data.representative,
        mainPhoneNum: data.mainPhoneNum,
        fax: data.fax,
        email: data.email,
        dongCode: data.dongCode,
        extraAddress: data.extraAddress,
        // tbFile: data.tbFile,
        fileCode: data.fileCode,
        note: data.note
        // hnFlag: String(true),
        // duruFlag: String(false)
      }
    } else if (data.hnDuruGubun.indexOf('홈네트워크') < 0 && data.hnDuruGubun.indexOf('정보통신') >= 0) {
      reqData = {
        hnDuruGubun: data.hnDuruGubun,
        consignCompName: data.consignCompName,
        businessNum: data.businessNum,
        representative: data.representative,
        mainPhoneNum: data.mainPhoneNum,
        fax: data.fax,
        email: data.email,
        dongCode: data.dongCode,
        extraAddress: data.extraAddress,
        // tbFile: data.tbFile,
        fileCode: data.fileCode,
        note: data.note
        // hnFlag: String(false),
        // duruFlag: String(true)
      }
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: reqData
    }
    console.log('actions insert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [data, callback]) { // 수정
    console.log('actions update data : ', data)
    const reqData = {
      hnDuruGubun: data.hnDuruGubun,
      consignCompSeq: data.consignCompSeq,
      consignCompName: data.consignCompName,
      businessNum: data.businessNum,
      representative: data.representative,
      mainPhoneNum: data.mainPhoneNum,
      fax: data.fax,
      email: data.email,
      dongCode: data.dongCode,
      extraAddress: data.extraAddress,
      // tbFile: data.tbFile,
      fileCode: data.fileCode,
      note: data.note
      // hnFlag: String(data.hnFlag),
      // duruFlag: String(data.duruFlag)
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descInsert: function (_context, [param, callback]) { // 특이사항 등록
    const reqData = {
      consignCompSeq: param.consignCompSeq,
      desc: param.desc
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descInsert',
      data: reqData
    }
    console.log('descInsert data : ', axiosOption.data)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descUpdate: function (_context, [param, callback]) { // 특이사항 수정
    const reqData = {
      consignCompSeq: param.consignCompSeq,
      consignCompDtlSeq: param.consignCompDtlSeq,
      updateUserSeq: param.updateUserSeq,
      desc: param.desc
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descUpdate',
      data: reqData
    }
    console.log('actions descUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descDelete: function (_context, [param, callback]) { // 특이사항 삭제
    const reqData = {
      consignCompSeq: param.consignCompSeq,
      consignCompDtlSeq: param.consignCompDtlSeq
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descDelete',
      data: reqData
    }
    console.log('actions descDelete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  delete: function (_context, [param, callback]) { // 미사용 처리
    const reqData = {
      consignCompSeq: param.consignCompSeq
      // hnDuruGubun: param.hnDuruGubun
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'delete',
      data: reqData
    }
    console.log('actions delete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeUpdate: function (_context, [data, callback]) {
    console.log('fileCodeUpdate : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeUpdate',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeInit: function (_context, [data, callback]) {
    console.log('fileCodeInit actions : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeInit',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
